import {FC} from "react";
import {Route, Routes} from "react-router";
import Background from "../atoms/Background.tsx";
import IndexPage from "./IndexPage.tsx";
import LoginCallbackPage from "./LoginCallbackPage.tsx";
import UserIndex from "./user";
import IssueReportingPage from "./IssueReportingPage.tsx";

const Index: FC = () => {
    return <Background>
            <Routes>
                <Route index element={<IndexPage />} />
                <Route path="/login" element={<LoginCallbackPage />} />
                <Route path="/u/*" element={<UserIndex />} />
                <Route path="/feedback/:siteId/:siteIdCode" element={<IssueReportingPage />} />
            </Routes>
        </Background>
}

export default Index;